import { termConstants } from '../constants/term.constants';
import termService from '../services/term.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const termActions = {
  fetch,
  get,
  save,
  remove,
  fetchAcceptances,
};

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const terms = await termService.fetch(params);
      dispatch(success(terms));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: termConstants.FETCH_REQUEST } }
  function success(terms) { return { type: termConstants.FETCH_SUCCESS, terms } }
  function failure(error) { return { type: termConstants.FETCH_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const term = await termService.get(id);
      dispatch(success(term));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: termConstants.GET_REQUEST } }
  function success(term) { return { type: termConstants.GET_SUCCESS, term } }
  function failure(error) { return { type: termConstants.GET_FAILURE, error } }
}

function save(obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const term = await termService.save(obj);
      dispatch(success(term));
      dispatch(alertActions.success('Termo salvo'));
      history.push('/settings/terms');
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: termConstants.SAVE_REQUEST } }
  function success(term) { return { type: termConstants.SAVE_SUCCESS, term } }
  function failure(error) { return { type: termConstants.SAVE_FAILURE, error } }
}

function remove(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await termService.remove(id);
      dispatch(success(result));
      dispatch(alertActions.success('Termo removido'));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: termConstants.DELETE_REQUEST } }
  function success(result) { return { type: termConstants.DELETE_SUCCESS, result } }
  function failure(error) { return { type: termConstants.DELETE_FAILURE, error } }
}

function fetchAcceptances(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const acceptances = await termService.fetchAcceptances(params);
      dispatch(success(acceptances));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: termConstants.ACCEPTANCES_FETCH_REQUEST } }
  function success(acceptances) { return { type: termConstants.ACCEPTANCES_FETCH_SUCCESS, acceptances } }
  function failure(error) { return { type: termConstants.ACCEPTANCES_FETCH_FAILURE, error } }
}
